/**
 * All API urls and other constants will reside here.
 * It is always a good idea to keep a local copy of all API response to
 * keep your app working for UI changes and
 * make it independent of network requirements.
 *
 * They need to be categorised and grouped together as:
 *  - Actual endpoints url.
 *  - Local data .json file path.
 * At a moment only one group should be uncommented.
 *
 * Other way to deal with this is to name every json file as per your service endpoint and use a basepath variable.
 * Toggle this basePath variable between "actual-domain.com/" or "/data/".
 */

// Actual endpoints. Uncomment below section to use actual data.
// export const GET_ALL_USERS = () => `https://jsonplaceholder.typicode.com/users`;
// export const GET_USER_DETAILS = (id) => `https://jsonplaceholder.typicode.com/users/${id}`;

// Local endpoints. Uncomment below section to use dummy local data.
// export const BASE_URL = () => `http://localhost:5001/api/v1/`;
export const BASE_URL = () =>
  `https://app-astt-api-dev.azurewebsites.net/api/v1/`;
export const GET_ALL_USERS = () => `/data/users`;
export const GET_USER_DETAILS = (id) => `/data/user`;
export const GET_ROSTER_DETAILS = () =>
  `agenttrackerclassrequest/getrosterbyid`;
export const GET_AGENT_TRACKER_SEARCH = () => `agenttrackersearch/searchTypes`;
export const GET_PARENT_CLIENT_SEARCH = () =>
  `agenttrackersearch/parentclientlist`;
export const GET_PARENT_CLIENT = () => `agenttrackersearch/searchParentClient`;
export const SEARCH_CLASS_REQUET_DETAILS = () =>
  `agenttrackersearch/searchClassRequestDetails`;
export const GET_ALL_ROSTER_STATUS = () =>
  `agenttrackersearch/getAllRosterStatus`;
export const GET_CLASS_ROSTER_WITH_STATUS = () =>
  `agenttrackersearch/getClassRosterWithStatus`;
export const GET_CLASS_ROSTER_DETAILS_WITH_REQUEST_ROSTER_ID = () =>
  `agenttrackersearch/getClassRosterDetails`;
export const GET_ASTT_HOME_ASSIGNED_ROSTERS = () =>
  `agenttrackersearch/getAsttHomeAssignedRosters`;
export const GET_TRAINEE_DETAILS_BY_ROSTER_ID = () =>
  `agenttrackersearch/getTraineeDetailsByRosterId`;
export const REACTIVATE_CLASS_TRAINEE = () =>
  `agenttrackersearch/reactivateClassTrainee`;
export const GET_REQUISITION_LIST = () =>
  `agenttrackersearch/getRequisitionList`;
export const GET_REQUISITION_DETAILS = () =>
  `agenttrackersearch/getRequisitionDetails`;
export const GET_ROSTER_DETAILS_BY_REQUISITION_ID = () =>
  `agenttrackersearch/getRosterDetailsByRequisitionId`;
export const GET_PARENT_CLIENT_DETAILS = () =>
  `agenttrackersearch/getParentClientDetailsForClassRequest`;
export const GET_CLASS_REQUEST = () =>
  `agenttrackerclassrequest/classrequestdetails`;
export const GET_PROJECT_DETAILS = () =>
  `agenttrackerclassrequest/projectdetails`;
export const GET_SITE_LOC = () => `agenttrackerclassrequest/getsitelist`;
export const UPDATE_CLASS_REQUEST = () =>
  `agenttrackerclassrequest/updateclassrequest`;
export const CREATE_CLASS_REQUEST = () =>
  `agenttrackerclassrequest/createclassrequest`;
export const GET_ROSTER_CONFIG = () => `agenttrackerclassroster/classroster`;
export const GET_ROSTER_CONFIG_BY_ID = () =>
  `agenttrackerclassroster/getRosterConfigDetails`;
export const TECH_EQUIPMENT_SOLUTION = () =>
  `agenttrackerclassroster/technicalequipmentsolutions`;
export const DISTRIBUTION_TYPE = () =>
  `agenttrackerclassroster/distributiontypes`;
export const FINGER_PRINTING = () => `agenttrackerclassroster/fingerprintings`;
export const ADJUDICATION = () => `agenttrackerclassroster/adjudications`;
export const LANGUAGE = () => `agenttrackerclassroster/languages`;
export const UPDATE_ROSTER_CONFIG = () =>
  `agenttrackerclassroster/updateclassRoster`;
export const GET_IDM_DETAILS = () =>
  `agenttrackerclassroster/RetrieveIDMTicket`;
export const INSERT_IDM_TICKET = () =>
  `agenttrackerclassroster/InsertIDMTicket`;
export const INSERT_FACILITIES_TICKET = () =>
  `agenttrackerclassroster/InsertFacilitiesTicket`;
export const DELETE_IDM_AND_FAC_TICKET = () =>
  `agenttrackerclassroster/DeleteIDMAndFacTicket`;
export const GET_UNASSIGNED_TRAINEE = () =>
  `agenttrackerclassroster/unassignedtrainee`;
export const GET_SEARCH_VALUE = () => `agenttrackerclassroster/Employee`;
export const VIEW_ASSIGNED_TRAINEE = () =>
  `agenttrackerclassroster/getTraineeDetails`;
export const DELETE_ROSTER = () => `agenttrackerclassroster/DeleteRoster`;
export const GET_TRAINEE_STATUS = () =>
  "agenttrackerclassroster/traineetransferstatus";
export const GET_PARENT_CLIENT_LIST = () =>
  "agenttrackersearch/parentclientlist";
export const GET_CONFIGURATION_VALUES = () =>
  "agenttrackersearch/getConfigurationValue";
export const GET_REASON_DETAILS = () =>
  "agenttrackerclassroster/traineestatusreason";
export const GET_ROSTER_ID = () =>
  "agenttrackerclassroster/classrostersfortransfer";
export const POST_RESCHEDULE = () =>
  `agenttrackerclassroster/transferclassrostertrainee`;
export const SEARCH_EMPLOYEE_PROFILE = () =>
  `agenttrackerclassroster/searchEmployeeProfile`;
export const SEARCH_CLASS_TRAINEE_PROFILE = () =>
  `agenttrackerclassroster/searchClassTraineeProfile`;
export const SAVE_ROSTER_CONFIG_DETAILS = () =>
  `agenttrackerclassroster/saveRosterConfigDetails`;
export const BULK_ATTENDANCE = () =>
  `agenttrackerbulkedit/OverrideGet_Attendance`;
export const BULK_STATUSDISPOSITION = () =>
  `agenttrackerbulkedit/OverrideGet_StatusDisposition`;
export const BULK_SAVESTATUSDISPOSITION = () =>
  `agenttrackerbulkedit/savestatusdisposition`;
export const BULK_EMPLOYEE_TICKET = () =>
  `agenttrackerbulkedit/OverrideGet_EmployeeTicketsComments`;
export const SAVE_EMPLOYEE_TICKET = () =>
  `agenttrackerbulkedit/saveemployeeticketcomments`;
export const GET_STATUS_DISPOSITION = () =>
  `agenttrackerbulkedit/OverrideGet_StatusDisposition`;
export const UPDATE_STATUS_DISPOSITION = () =>
  `agenttrackerbulkedit/savestatusdispositionoverride`;
export const GET_TPC = () => `agenttrackerbulkedit/OverrideGet_TPC`;
export const GET_PRODUCT_TRAINING = () =>
  `agenttrackerbulkedit/OverrideGet_Product`;
export const GET_TTF = () => `agenttrackerbulkedit/OverrideGet_TTE`;
export const CREATE_ROSTER = () => `agenttrackerclassroster/createclassRoster`;
export const SAVE_ATTENDANCE = () => `agenttrackerbulkedit/saveattendance`;
export const SAVE_TTF = () => `agenttrackerbulkedit/savette`;
export const SAVE_TPC = () => `agenttrackerbulkedit/savetpc`;
export const SAVE_PRODUCT_TRAINING = () => `agenttrackerbulkedit/saveproduct`;
export const GET_ACC_DATA = () => `agenttrackerbulkedit/OverrideGet_ACC`;
export const SAVE_ACC = () => `agenttrackerbulkedit/saveacc`;
export const BULK_EMPLOYEE_EQUIPMENT = () =>
  `agenttrackerbulkedit/OverrideGet_ELAEquipmentShipment`;
export const BULK_SAVE_EMPLOYEE_EQUIPMENT = () =>
  `agenttrackerbulkedit/saveemployeeequipment`;
export const BULK_GET_CLASS = () => `agenttrackerbulkedit/OverrideGet_Class`;
export const BULK_POST_CLASS = () => `agenttrackerbulkedit/saveclass`;
export const GET_TECH_SOL = () =>
  `agenttrackerclassroster/technicalequipmentsolutions`;
export const OVERRIDE_GET_EMPLOYEE = () =>
  `agenttrackerbulkedit/OverrideGet_Employee`;
export const OVERRIDE_GET_MILESTONE = () =>
  `agenttrackerbulkedit/OverrideGet_Milestone`;
export const SAVE_EMPLOYEES = () => `agenttrackerbulkedit/saveemployee`;
export const SAVE_MILESTONES = () => `agenttrackerbulkedit/saveclassmilestones`;
export const OVERRIDE_GET_TCI = () => `agenttrackerbulkedit/OverrideGet_TCI`;
export const SAVE_TCI = () => `agenttrackerbulkedit/savetci`;
export const OVERRIDE_GET_TTD = () =>
  `agenttrackerbulkedit/OverrideGet_TechTest`;
export const SAVE_TTD = () => `agenttrackerbulkedit/savetechtest`;
export const SEARCH_TRAINEE = () => `agenttrackersearch/searchtrainee`;
export const SEARCH_CLASS_TRAINEE_BY_SEARCH_TYPE = () =>
  `agenttrackersearch/searchClassTraineeBySearchType`;
export const SAVE_TRAINEE_ROSTER = () =>
  `agenttrackerclassroster/CreateClassRosterTrainee`;
export const GET_TRAINEE_ROSTER = () =>
  `agenttrackerclassroster/getTraineeDetails`;
export const GET_FILE_ATTACHMENT = () =>
  `agenttrackerclassrequest/getfileattachmenttypes`;
export const SAVE_FILE_ATTACHMENT = () =>
  `agenttrackerclassrequest/savefileattachment`;
export const SAVE_RESCHEDULE_TRANSFER = () =>
  `agenttrackerclassroster/transferclassrostertrainee`;
export const ROSTER_HISTORY = () => `agenttrackerclassroster/RosterHistory`;
export const DELETE_FILE_ATTACHMENT = () =>
  `agenttrackerclassrequest/deletefileattachmentinfo`;
export const GET_ROSTER_IDM_TRAINEES_DETAIL = () =>
  "agenttrackerclassroster/RosterIDMTicketDetail";
export const GET_TRAINEE_DETAILS_FOR_IDMTICKET_BY_ROSTERID = () =>
  "agenttrackerclassroster/getTraineeDetailsForIDMTicketByRosterId";
export const GET_IDM_CURRENT_CLIENT_PROGRAM = () =>
  "agenttrackerclassroster/Get_IDMCurrCPDetailsByName";
export const GET_IDM_NEW_CLIENT_PROGRAM = () =>
  "agenttrackerclassroster/Get_IDMNewCPDetailsByName";
export const ROSTER_LOCK = () => `agenttrackerclassroster/updaterosterlock`;
export const GET_WAVE = () =>
  `agenttrackerclassrequest/getwavebyclassrequestid`;
export const VIEW_TRAINEE_DETAILS = () => `agenttrackersearch/traineedetails`;
export const FILE_ATTACHMENT_DETAILS = () =>
  `agenttrackerclassrequest/getfileattachmentdetails`;
export const GET_ATTENDANCE_NA = () =>
  `agenttrackerclassroster/getattendancena`;
export const GET_IDM_SITE_LOCATION = () =>
  "agenttrackerclassrequest/getSiteGeoLocationDetails";
export const GET_IDM_CLIENT_PROGRAM = () =>
  "agenttrackerclassroster/GetIDMASkNowCPDetails";
export const GET_IDM_EMPLOYEE_LIST = () =>
  "agenttrackerclassroster/employeelist";
export const GET_IDM_USER_DETAILBYID = () =>
  "agenttrackerclassroster/Get_IDMUserdetailById";
export const GET_TALEO_REQ_IDS = () =>
  "agenttrackerclassroster/getAssociatedTaleoReqIds";
export const GET_IDM_TECH_DEP_TYPE_LIST = () =>
  "agenttrackerclassroster/technologydeploymenttypelist";
export const IDM_CREATE_ORDER_REQUEST = () =>
  `agenttrackerclassroster/Get_IDMCreateOrderRequest`;
export const GET_IDM_RITM_DETAIL = () =>
  "agenttrackerclassroster/RetrieveRITMDetail";
export const SAVE_ATTACHMENT_RITM = () =>
  `agenttrackerclassroster/AttachToRITM`;
export const SAVE_ATTACHMENT_FACILITIES = () =>
  `agenttrackerclassroster/AttachToFacilities`;
export const SAVE_ATTACHMENT_RITM_CLIENT = () =>
  `agenttrackerclassroster/AttachToRITMForClient`;
export const SAVE_ATTACHMENT_RITM_CAPCLIENT = () =>
  `agenttrackerclassroster/AttachToRITMForCapClient`;
export const GET_ROSTER_ID_LIST = () =>
  "agenttrackerclassroster/GetEmployeeRosterList";
export const EMPLOYEE_PII_ELIGIBLE = () =>
  "agenttrackerclassroster/CheckEmployeePIIReportEligible";
export const GET_PII_DATA = () =>
  "agenttrackerclassroster/GetEmployeePIIReport";
export const GET_PII_DATA_BY_ORACLEID = () =>
  "agenttrackerclassroster/GetPIIDatabyOracleId";
export const SAVE_RITM_COMMENT = () =>
  "agenttrackerclassroster/insertidmcomment";
export const GET_OBT_MANAGEMENT_INFO = () =>
  "agenttrackerclassroster/GetOBTManagementInfo";
export const GET_OBT_MANAGEMENT_INFO_BY_ID = () =>
  "agenttrackerclassroster/GetOBTManagementInfoById";
export const SAVE_OBT_EMAIL_DETAILS = () =>
  "agenttrackerclassroster/saveOBTEmailDetails";
export const GET_ASKNOW_BS_TASK_DETAILS = () =>
  "agenttrackerclassroster/GetAsknowBSTaskDetails";
export const SAVE_ASKNOW_BS_TASK_DETAILS = () =>
  "agenttrackerclassroster/SaveAsknowBSTaskDetails";
export const SAVE_OBT_INFO = () => "agenttrackerbulkedit/saveobtinfo";
export const REFRESH_TRACKING_STATUS = () =>
  `agenttrackerbulkedit/RefeshTrackingStatus`;
export const GET_INFORMATIC_CLIENT = () =>
  `agenttrackerclassroster/GetInformaticaClientDetails`;
export const GET_EMPLOYEE_ADSTATUS_BY_ORACLEID = () =>
  `agenttrackerclassroster/getEmployeeADStatusByOracleId`;
export const GET_IDM_TICKET_DETAILS = () =>
  `agenttrackerbulkedit/getIDMticketsdetailByRosterId`;
export const GET_INFORMATICA_EMPLOYEE_DATA = () =>
  `agenttrackerclassroster/informaticaEmployeeData`;
export const GET_CURRENT_EQUIPMENT_SETUP = () =>
  `agenttrackerclassroster/currentequipmentsetup`;
export const GET_ORACLEIDSPII = () => `agenttrackerclassroster/getOracleidsPII`;
export const GET_ORACLEIDSPIIBY_FACILITIESTICKETNUMBER = () =>
  `agenttrackerclassroster/getOracleidsPIIByFacilitiesTicketNumber`;
export const GET_ORACLEIDS = () => `agenttrackerclassroster/getoracleids`;
export const GET_PII_IDMTICKET = () =>
  `agenttrackerclassroster/informaticaEmployeeData`;
export const GET_ALL_CLASSREQIDs = () =>
  `agenttrackerclassrequest/getAllClassRequestIds`;
export const GET_ROSTER_TRAINEES_BY_CLASSREQIDs = () =>
  "agenttrackerclassrequest/getRosterTraineesByClassRequestId";
export const GET_ROSTERCONFIGDETAILS_FOR_ASSIGNTRAINEE = () =>
  "agenttrackerclassrequest/getRosterConfigDetailsForAssignTrainee";
export const SAVE_ASSIGN_TRAINEES = () =>
  "agenttrackerclassroster/CreateMultipleClassRosterTrainee";
export const GET_OSR_APPROVING_AUTHORITY_EMAIL = () =>
  `agenttrackerclassrequest/getOSRApprovingAuthorityEmailIds`;
export const CREATE_OVERNIGHT_SHIPPING_REQUEST = () =>
  `agenttrackerclassrequest/createovernightshippingrequest`;
export const SAVE_ROSTER_MANAGEMENT_FIELDS = () =>
  `agenttrackerclassroster/SaveRosterManagementConfigDetails`;

export const GET_AGENT_COMMENTS_BYROSTERID = () =>
  `agenttrackerclassroster/getAgentCommentsByRosterId`;
export const GET_NEW_CLIENT_PROGRAM = () =>
  "agenttrackerclassrequest/getClientProgramDetails";
export const SAVE_ROSTERREQUISITION = () =>
  `agenttrackerclassroster/RosterRequisitionMap`;
export const REMOVE_ROSTER_REQUISITION_MAP = () =>
  `agenttrackerclassroster/RemoveRosterRequisitionMap`;
export const GET_ROSTERMILESTONE_SEARCHRESULTS = () =>
  "agenttrackerclassroster/getRosterMilestoneSearchResults";
export const GET_TRAINEEMILESTONE_ASSOCIATE = () =>
  "agenttrackerclassroster/getTraineeMilestoneAssociate";
export const DELETE_MILESTONE_ASSOCIATE = () =>
  "agenttrackerclassroster/deleteMilestoneAssociate";
export const GET_ALL_MILESTONES = () =>
  "agenttrackerclassroster/getAllMilestones";
export const GET_ALL_MILESTONES_WITH_STATUSES = () =>
  "agenttrackerclassroster/getAllMilestonesWithStatuses";
export const SAVE_MILESTONEEDIT = () => "agenttrackerclassroster/EditMilestone";
export const SAVE_CLASSROSTERMILESTONES = () =>
  "agenttrackerclassroster/CreateClassrosterMilestone";
export const UPDATE_MILESTONEREORDER = () =>
  "agenttrackerclassroster/updatemilestonesReorder";
export const CREATE_MILESTONE = () => "agenttrackerclassroster/CreateMilestone";
export const SAVE_MILESTONESTATUSEDIT = () =>
  "agenttrackerclassroster/EditMilestoneStatus";
export const CREATE_MILESTONESTATUS = () =>
  "agenttrackerclassroster/CreateMilestoneStatus";
export const GET_MILESTONE_DATATYPE = () =>
  "agenttrackerclassroster/getAllMilestoneDataType";
export const GET_MILESTONE_WITH_LIST_TYPE = () =>
  "agenttrackerclassroster/getMilestoneWithListType";
export const GET_BULK_MILESTONE_COUNT = () =>
  "agenttrackerclassroster/getBulkMilestoneCount";
export const INSERT_BULK_MILESTONE = () =>
  "agenttrackerclassroster/insertBulkMilestone";
export const SAVE_APPLICATION_USAGE = () =>
  `agenttrackersearch/CreateApplicationUsage`;
export const CREATE_PII_AUDIT_LOG = () =>
  `agenttrackersearch/CreatePIIAuditLog`;
export const GET_RELEASEUPDATES = () => `agenttrackersearch/getReleaseUpdates`;
export const CREATE_RELEASEUPDATE = () =>
  `agenttrackersearch/CreateReleaseUpdate`;
export const UPDATE_RELEASEUPDATE = () =>
  `agenttrackersearch/UpdateReleaseUpdate`;
export const DELETE_RELEASEUPDATE = () =>
  "agenttrackersearch/DeleteReleaseUpdate";
export const UPLOAD_AGENT_SCHEDULE_DOC_LIB = () =>
  `agenttrackerclassroster/generateAgentScheduleByRoster`;
export const GET_CONFIRM_AGENT_SCHEDULE_BY_ROSTER = () =>
  `agenttrackerclassroster/getConfirmAgentScheduleByRoster`;
export const GET_TRAINEE_PRODUCTION_SCHEDULE = () =>
  `agenttrackerclassroster/getTraineeProductionSchedule`;
export const GET_IDMROSTER_LIST = () =>
  "agenttrackerclassroster/getIdmRosterList";
export const GET_IDMROSTER_DETAILS = () =>
  "agenttrackerclassroster/getIdmRosterDetails";
export const GET_IDMCREDENTIAL_ROSTER_DETAILS_BY_TRACKINGID = () =>
  "agenttrackerclassroster/getIdmCredentialRosterDetailsByTrackingId";
export const GET_IDMCREDENTIAL_BY_TRACKINGID = () =>
  "agenttrackerclassroster/getIdmCredentialDetailByTrackingId";
export const GET_IDMSYSTEM_IMPACTED = () =>
  "agenttrackerclassroster/getIdmSystemImpacted";
export const GET_IDMSWITCH_TYPE = () =>
  "agenttrackerclassroster/getIdmSwitchType";
export const GET_IDM_SANITY_CHECKNOTES = () =>
  "agenttrackerclassroster/getIdmSanityCheckNotes";
export const GET_IDM_ISSUE_DESCRIPTION = () =>
  "agenttrackerclassroster/getIdmIssueDescription";
export const CREATE_IDMCREDENTIALTRACKING = () =>
  "agenttrackerclassroster/insertIdmCredential";
export const UPDATE_IDMCREDENTIALTRACKING = () =>
  "agenttrackerclassroster/updateIdmCredential";
export const DELETE_IDMCREDENTIALTRACKING = () =>
  "agenttrackerclassroster/deleteIdmCredential";
export const GET_IDM_CREDENTIALS_BY_PRODUCTTRAINING_MONTH = () =>
  "agenttrackerclassroster/getIdmCredentialsByProductTrainingMonth";
export const IDMCREDENTIALTRACKING_LOCK = () =>
  `agenttrackerclassroster/UpdateIdmCredentialLock`;
export const ACCESS_REQUEST = () => "asknowrequest/CreateAskNowAccessRequest";
export const CREATE_IDMEMAILQUEQE = () =>
  "agenttrackerclassroster/insertIdmEmailQueue";
export const GET_ALLCLIENTS = () => "agenttrackerclassroster/getAllClients";
export const GET_PROJECTS_BY_CLIENTCODE = () =>
  "agenttrackerclassroster/getProjectsByClientCode";
export const GET_OBTMANAGEMENTINFO_BY_PROJECTCODE = () =>
  "agenttrackerclassroster/getOBTManagementInfoByProject";
export const CREATE_FACILITIES_REQUEST = () =>
  "asknowrequest/CreateAskNowFacilitiesRequest";
export const GET_AIPROMPT_RESPONSE = () => "vertexAI/generateWithAIPrompt";
export const UPDATE_DATANITIV_CLASS_LIB = () =>
  `agenttrackerclassroster/updateDataNitivClassId`;
export const OVERRIDE_GET_EMPLOYEEDATA = () =>
  `agenttrackerbulkedit/OverrideGet_EmployeeData`;
export const SAVE_EMPLOYEEDATA = () =>
  `agenttrackerbulkedit/SaveEmployeeDataBulkEdit`;
export const BULK_GET_CLASSDATA = () =>
  `agenttrackerbulkedit/OverrideGet_ClassData`;
export const SAVE_CLASSDATA = () =>
  `agenttrackerbulkedit/SaveClassDataBulkEdit`;
// LearnPoint starts here..

export const GET_LD_PARENT_CLIENT = () => `learnPoint/getAllParentClients`;
export const GET_LD_COUNTRY_CODE = () => `learnPoint/getAllCountryCodes`;
export const GET_LD_SITE_CODE = () => `learnPoint/getAllSiteCodes`;
export const GET_LD_CLIENT = () => `learnPoint/getClientsByParentClientId`;
export const GET_LD_PROGRAM = () => `learnPoint/getProgramsByParentClientId`;
export const GET_LD_PROJECT = () => `learnPoint/getProjectsByParentClientId`;
export const GET_LD_ACTIVE_VISITOR = () => `learnPoint/getActiveVisitors`;
export const GET_LD_FRAMEWORK_VISITOR = () => `learnPoint/getFrameworkVisitor`;
export const SAVE_LD_FRAMEWORK_VISITOR = () =>
  `learnPoint/updateFrameworkVisitor`;
export const DELETE_LD_FRAMEWORK_VISITOR = () =>
  `learnPoint/deleteFrameworkVisitor`;
export const ADD_LD_FRAMEWORK_VISITOR = () =>
  `learnPoint/insertFrameworkVisitor`;
export const GET_LD_ACTIVE_SEGMENT = () => `learnPoint/getActiveSegments`;
export const GET_LD_FRAMEWORK_SEGMENT = () => `learnPoint/getFrameworkSegment`;
export const ADD_LD_FRAMEWORK_SEGMENT = () =>
  `learnPoint/insertFrameworkSegment`;
export const SAVE_LD_FRAMEWORK_SEGMENT = () =>
  `learnPoint/updateFrameworkSegment`;
export const DELETE_LD_FRAMEWORK_SEGMENT = () =>
  `learnPoint/deleteFrameworkSegment`;
export const GET_FRAMEWORK_SEARCH_RESULTS = () =>
  `learnPoint/getFrameworkSearchResults`;
export const FILTER_FRAMEWORKS = () => `learnPoint/filterFramework`;
export const GET_FRAMEWORK = () => `learnpoint/selectFramework`;
export const UPDATE_FRAMEWORK = () => `learnpoint/updateFramework`;
export const GET_CURRICULUM_STATUS = () => "learnPoint/getCurriculumStatus";
export const FILTER_CLASS_ROSTER_BY_TRAINER_EMAIL = () =>
  "learnPoint/filterClassRosterByTrainerEmail";
// ASTT-7319: "Recent Roster(s)" grouping, per stakeholder-demo feedback.
export const GET_RECENT_ROSTERS_FOR_USER = () =>
  "learnPoint/getRecentRostersForUser";
export const FILTER_CLASS_ROSTER_BY_TRAINEE_EMAIL = () =>
  "learnPoint/filterClassRosterByTraineeEmail";
export const GET_CLASS_ROSTER_DETAILS = () =>
  "learnPoint/filterLPClassRosterRequest";
export const GET_CONTENT_SEARCH_VALUE = () =>
  `learnPoint/FilterTraineePopoverContent`;
export const GET_CLASS_ROSTER_DATAGRID_DETAILS = () =>
  "learnPoint/getClassRosterMilestoneDetails";
export const GET_CLASS_TRAINEE_MILESTONE_DETAILS = () =>
  "learnPoint/getClassTraineeMilestoneDetails";
export const GET_MILESTONE_BY_ROSTER_ID = () =>
  "learnPoint/getMilestoneByRosterId";
export const GET_MILESTONE_STATUS_BY_ROSTER_ID = () =>
  "learnPoint/getMilestoneStatusByRosterId";
export const GET_TRAINEE_STATUS_LIST = () => "learnPoint/getTraineeStatusList";
export const UPDATE_CLASS_TRAINEE_MILESTONE_GRID = () =>
  "learnPoint/updateClassTraineeMilestoneRequest";
export const UPDATE_CURRICULUM_STATUS = () =>
  "learnPoint/updateClassRosterCurriculumStatus";
export const GET_ALL_CLASSTYPES = () => "learnpoint/getClassTypes";
export const GET_FRAMEWORK_MILESTONES = () =>
  `learnPoint/FrameworkDefaultMilestones`;
export const SAVE_FRAMEWORK_MILESTONES = () =>
  `learnPoint/FrameworkDefaultMilestones`;
export const GET_MERGE_CLASS_TRAINEE_MILESTONE_DETAILS = () =>
  "learnPoint/getMergeClassTraineeMilestoneDetails";
export const GET_MILESTONE_BY_MERGE_ROSTER_ID = () =>
  "learnPoint/getMilestoneByMergeRosterId";
export const UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID = () =>
  "learnPoint/updateMergeClassTraineeMilestoneRequest";
export const BULK_UPDATE_CLASS_TRAINEE_MILESTONE_GRID = () =>
  "learnPoint/bulkUpdateClassTraineeMilestoneRequest";
export const BULK_UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID = () =>
  "learnPoint/bulkUpdateMergeClassTraineeMilestoneRequest";
export const UPDATE_MERGE_CLASSROSTER_CURRICULUM_STATUS = () =>
  "learnPoint/updateMergeClassRosterCurriculumStatus";
export const GET_MERGE_CLASS_ROSTER_DETAILS = () =>
  "learnPoint/getFilteredClassRequestByMergeRoster";
export const GET_EMPLOYEE_DETAILS_CENTERPOINT = () =>
  "centerPoint/getAllEmployeeDetails";
export const GET_ALL_JOB_NAMES = () => "centerPoint/getAllJobNames";
export const GET_ALL_LOCATIONS = () => "centerPoint/getAllLocations";
export const GET_CENTERPOINT_EMPLOYEE_DETAILS = () =>
  "centerPoint/getEmployeeDetails";
export const GET_PARENT_CLIENT_CENTERPOINT = () =>
  "centerPoint/getAllParentClients";
export const GET_CLIENT_CENTERPOINT = () =>
  "centerPoint/getClientsByParentClientId";
export const GET_PROGRAM_CENTERPOINT = () =>
  "centerPoint/getProgramsByParentClientId";
export const GET_PROJECT_CENTERPOINT = () =>
  "centerPoint/getProjectsByParentClientId";
export const GET_ALL_SUBSYTEMS = () => "centerPoint/getAllSubSystems";
export const GET_LOGONIDS_BY_SUBSYSTEMS = () =>
  "centerPoint/getLogOnIdsBySubSystemId";
export const SEARCH_CENTERPOINT_EMPLOYEES = () =>
  "centerPoint/getEmployeeSearchResults";
export const GET_SYSTEM_DETAILS = () => "centerPoint/getSystemDetails";
export const DELETE_SYSTEM_DETAILS = () => "centerPoint/deleteSystemDetails";
export const CREATE_FRAMEWORK = () => "learnpoint/insertFramework";
export const GET_ALL_SYSTEMS_TYPE = () => "centerPoint/getAllSystemTypes";
export const GET_ALL_SYSTEMS_BY_SYSTEM_TYPE_ID = () =>
  "centerPoint/getAllSystemsBySystemTypeId";
export const GET_ALL_SUBSYTEMS_BY_SYSTEM_TYPE_ID = () =>
  "centerPoint/getAllSubSystemsBySystemTypeId";
export const ADD_SYSTEM = () => "centerPoint/insertSystemDetails";
export const EDIT_SYSTEM = () => "centerPoint/updateSystemDetails";
export const VALIDATE_BULK_UPLOAD_EXCEL_DATA = () =>
  "centerPoint/validationBulkUpload";
export const INSERT_UPLOADED_FILE = () => "centerPoint/insertBulkUpload";
export const GET_ALL_SYSTEMS = () => "centerPoint/getAllSystems";
export const GET_ALL_SUBSYTEMS_BY_SYSTEM_ID = () =>
  "centerPoint/getAllSubSystemsBySystemId";
export const GET_SYSTEM_TRANSACTION_LOGS = () =>
  "centerPoint/getEmployeeSystemTransactionLogs";
export const GET_EMPLOYEE_NAME_FROM_AUDIT_LOGS = () =>
  "centerPoint/getEmployeeNameFromAuditLogs";
export const UPDATE_CLASS_ROSTER_HEADER = () =>
  `learnpoint/UpdateClassRosterHeader`;
export const GET_ALL_HR_SYSTEMS = () => "centerPoint/getAllHRSystems";
export const GET_ALL_CENTER_LOCATIONS = () =>
  "centerPoint/getAllCenterLocations";
export const GET_ALL_EMPLOYMENT_TYPES = () =>
  "centerPoint/getAllEmploymentTypes";
export const GET_ALL_EMPLOYMENT_STATUS = () =>
  "centerPoint/getAllEmploymentStatus";
export const GET_SUPERVISOR_DETAILS = () => "centerpoint/getSuperVisorDetails";
export const GET_ALL_CLIENTS = () => "centerpoint/getAllClients";
export const GET_ALL_PROGRAMS_BY_CLIENTID = () =>
  "centerPoint/getAllProgramsByClientId";
export const GET_ALL_PROJECTS_BY_CLIENT_AND_PROGRAM = () =>
  "centerPoint/getAllProjectsByClientIdAndProgramId";
export const GET_ALL_POSITIONS = () => "centerpoint";
export const GET_ALL_DEPARTMENTS = () => "centerpoint/getAllDepartments";
export const INSERT_NON_TTEC_EMPLOYEE = () =>
  "centerPoint/insertNonTTECEmployee";
export const GET_SYSTEM_DETAILS_BY_EMPLOYEE_ID = () =>
  "centerPoint/getSystemDetailsNonTtecEmployee";
export const VALIDATE_EMPLOYEE_ID = () =>
  "centerPoint/validateNonTtecEmployeeId";
export const FETCH_NON_HRMS_EMPLOYEE_DETAILS = () =>
  "centerPoint/getNonTTECEmployeeDetailsByExtEmployeeId";
export const UPDATE_NON_TTEC_EMPLOYEE_DETAIL = () =>
  "centerPoint/updateNonTTECEmployee";
export const GET_ORACLE_ID_BY_EMAIL_ID = () =>
  "asknowrequest/getOracleIdByEmailId";
export const REPORT_A_PROBLEM = () =>
  "asknowrequest/CreateAskNowIncidenceForReportProblem";
export const FEATURE_REQUEST = () =>
  "asknowrequest/CreateAskNowIncidenceForFeatureRequest";
export const NOAUTH_ACCESS_REQUEST = () =>
  "noauthcontroller/createAccessRequestOnAskNow";
export const GET_RITM_DETAILS = () => "noauthcontroller/retrieveRITMDetail";
export const GET_TRAINEE_ITAM_STATUS_BY_ROSTERID = () =>
  `agenttrackerclassroster/getTraineeITAMStatusByRosterId`;
export const REFRESH_ITAMSTATUS = () =>
  `agenttrackerclassroster/refreshITAMData`;
export const GET_DTR_LIST_ROSTER_WISE = () => "learnPoint/DtrListRosterWise";
export const GET_DTR_CLASS_DETAILS = () =>
  "learnPoint/getClassDetailsForDTRByClassRosterId";
// ASTT-7319: new, additive -- see the API controller's own comment on
// why this exists alongside GET_DTR_CLASS_DETAILS rather than replacing it.
export const GET_DTR_CLASS_DETAILS_PER_ROSTER = () =>
  "learnPoint/getClassDetailsForDTRPerRoster";
// ASTT-7319: two new drill-down endpoints ("View Projects"/"View Site").
export const GET_CLASS_ROSTER_PROJECT_DETAILS = () =>
  "learnPoint/getClassRosterProjectDetails";
export const GET_CLASS_ROSTER_SITE_DETAILS = () =>
  "learnPoint/getClassRosterSiteDetails";
// ASTT-7319: "View DTRs" drill-down (item 7).
export const GET_DTR_LIST_FOR_ROSTER = () =>
  "learnPoint/getDTRListForRoster";
export const GET_DTR_DATE_DETAILS = () =>
  "learnPoint/getDateDetailsForDTRByClassRosterId";
export const GET_DTR_TRAININGNOTES = () =>
  "learnPoint/getDTRTrainingNotesByClassRosterId";
export const SAVE_DTR_DRAFT = () => "learnPoint/CreateDTRTrainingNotes";
export const SEND_DTR_EMAIL = () => "learnPoint/sendDtrEmail";
// ASTT-7319: read-only preview, per direct stakeholder-demo feedback.
export const PREVIEW_DTR_EMAIL = () => "learnPoint/previewDtrEmail";
export const INSERT_DTR_DISTRO = () => "learnpoint/InsertDTRDistro";
export const UPDATE_DTR_DISTRO = () => "learnpoint/UpdateDTRDistro";
export const GET_ALL_DTR_DISTRO = () => "learnpoint/GetAllDTRDistro";
export const GET_DTR_ATTENDANCERANGE = () => "learnPoint/getDtrAttendanceRange";
export const GET_DTR_ATTENDANCE = () => "learnPoint/getDtrAttendance";
export const SAVE_HANDOFF_DRAFT = () => "learnPoint/CreateHandOffNotes";
export const GET_HANDOFF_NOTES = () => "learnPoint/HandOffNotesByClassRosterId";
export const SEND_HANDOFF_EMAIL = () => "learnPoint/sendHandOffEmail";
// ASTT-7319: Hand-Off Report's own read-only preview counterpart.
export const PREVIEW_HANDOFF_EMAIL = () => "learnPoint/previewHandOffEmail";
export const UPLOAD_DTR_ATTACHMENT = () => "learnPoint/UploadDTRAttachment";
export const GET_DTR_ATTACHMENTS = () => "learnPoint/GetDTRAttachments";
export const DELETE_DTR_ATTACHMENT = () => "learnPoint/DeleteDTRAttachment";
export const SAVE_DTR_TRAINING_NOTES_WITH_ATTACHMENTS = () =>
  "learnPoint/SaveDTRTrainingNotesWithAttachments";
export const SAVE_HANDOFF_REPORT_WITH_ATTACHMENTS = () =>
  "learnPoint/SaveHandOffReportWithAttachments";
export const GET_DTR_ATTACHMENTS_BY_PARENT_ID = () =>
  "learnPoint/GetDTRAttachmentsByParentId";
// ASTT-7319 follow-up: in-app inline-image display proxy -- see
// LearnPointController.cs's own endpoint comment for the full
// SharePoint-auth reasoning.
export const DOWNLOAD_ATTACHMENT_IMAGE = () =>
  "learnPoint/downloadAttachmentImage";

//OMT Starts Here....
export const GET_ALL_PARENTCLIENTS = () => "omtTracker/getAllParentClients";
export const GET_ALL_PROJECTS_BY_PARENTCLIENTCODE = () =>
  "omtTracker/getAllProjectsByParentClientCode";
export const GET_WAVE_BY_PROJECTCODE = () => "omtTracker/getWaveByProjectCode";
export const GET_CLASSROSTERS = () => "omtTracker/getClassRoster";
export const GET_CLASS_SEARCHRESULTS = () => "omtTracker/getClassSearchResults";
export const GET_ALL_NO_ROSTER_ID_CLASS = () =>
  "omtTracker/getAllNoRosterIdClass";
export const GET_ALL_TECHSOLUTIONS = () => "omtTracker/getAllTechSolutions";
export const GET_BULK_REBUILD_BY_TECHSOLUTIONID = () =>
  "omtTracker/getBulkRebuildeByTechSolutionId";
export const GET_ALL_TASKTYPES = () => "omtTracker/getAllTaskTypes";
export const GET_ALL_STATUS = () => "omtTracker/getAllStatus";
export const GET_OMT_CLASSDETAILS_HISTORY = () =>
  "omtTracker/getOMTClassDetailsHistory";
export const SAVE_OMT_CLASSDETAILS = () => "omtTracker/saveOMTClassDetails";
export const DELETE_OMT_CLASSSCHEDULE = () => "omtTracker/cancelOMTSchedule";
export const RESCHEDULE_DELETED_OMT_CLASSSCHEDULE = () =>
  "omtTracker/reschedulecancelledOMTSchedule";
export const GET_CLASSROSTERS_FORASDLEAD = () =>
  "omtTracker/getClassRosterForAsdLead";
export const GET_CLASSROSTERS_TASKTYPE = () =>
  "omtTracker/getOMTClassRosterTaskType";
export const GET_CLASSROSTERS_SCHEDULETYPE = () =>
  "omtTracker/getOMTClassRostersSchduleType";
export const GET_OMT_ATTENDANCE = () => "omtTracker/getOMTAttendance";
export const BULK_POST_OMT_ATTENDANCE = () => `omtTracker/saveOMTAttendance`;
export const GET_OMT_HARDWARE_STATUSES = () =>
  "omtTracker/getOMTHardwareStatus  ";
export const GET_OMT_HARDWARE = () => "omtTracker/getOMTHardware";
export const SAVE_OMT_HARDWARE = () => "omtTracker/saveOMTHardware";
export const GET_OMT_CREDENTIALS = () => "omtTracker/getOMTCredentials";
export const BULK_POST_OMT_CREDENTIALS = () => `omtTracker/saveOMTCredentials`;
export const GET_OMT_NETWORK = () => "omtTracker/getOMTNetwork";
export const BULK_POST_OMT_NETWORK = () => `omtTracker/saveOMTNetwork`;
export const GET_OMT_OPERATINGSYSTEM = () => "omtTracker/getOMTOperatingSystem";
export const BULK_POST_OMT_OPERATINGSYSTEM = () =>
  `omtTracker/saveOMTOperatingSystem`;
export const GET_OMT_APPLICATION = () => "omtTracker/getOMTApplication";
export const BULK_POST_OMT_APPLICATION = () => `omtTracker/saveOMTApplication`;
export const GET_OMT_ATTACHMENT = () => "omtTracker/getOMTAttachments";
export const SAVE_OMT_ATTACHMENT = () => `omtTracker/saveOMTAttachment`;
export const DELETE_OMT_ATTACHMENT = () => "omtTracker/deleteOMTAttachment";
export const GET_OMT_CLASSDETAILSFLAGS = () =>
  "omtTracker/getOMTClassDetailsFlags";
export const GET_DISTINCTTECHTYPES = () => "omtTracker/getDistinctTechTypes";
export const GET_OVERTURERESULT = () => "omtTracker/getOvertureResult";
export const JIRA_FEATURE_REQUEST = () =>
  "asknowrequest/createJiraFeatureRequest";
export const GET_CORE_RATIO_MAPPING = () => "coreRatio/GetCoreRatioMapping";
export const CREATE_CORE_RATIO_MAPPING = () =>
  "coreRatio/createCoreRatioMapping";
export const UPDATE_CORE_RATIO_MAPPING = () =>
  "coreRatio/updateCoreRatioMapping";
export const DELETE_CORE_RATIO_MAPPING = () =>
  "coreRatio/deleteCoreRatioMapping";
export const BULK_UPDATE_CORE_RATIO_MAPPINGS = () =>
  "coreRatio/bulkUpdateCoreRatioMappings";
export const GET_PROGRAMS = () => "coreRatio/getPrograms";
export const GET_CORE_RATIO_BUCKETS = () => "coreRatio/getCoreRatioBuckets";
export const GET_BILLABILITY_TYPES = () => "coreRatio/getBillabilityTypes";
export const GET_CORE_RATIO_BASIS = () => "coreRatio/getCoreRatioBasis";
export const GET_COUNTRIES = () => "coreRatio/getCountries";
export const GET_JOB_CODE_MAPPINGS = () => "coreRatio/getJobCodeMappings";
export const CREATE_JOB_CODE_MAPPING = () => "coreRatio/createJobCodeMapping";
export const UPDATE_JOB_CODE_MAPPING = () => "coreRatio/updateJobCodeMapping";
export const DELETE_JOB_CODE_MAPPING = () => "coreRatio/deleteJobCodeMapping";
export const BULK_UPDATE_JOB_CODE_MAPPINGS = () =>
  "coreRatio/bulkUpdateJobCodeMappings";
export const GET_DEPARTMENTS = () => "coreRatio/getDepartments";
export const GET_JOB_CODES = () => "coreRatio/getJobCodes";
export const SAVE_STATUSDISPOSITION_V2 = () =>
  `agenttrackerbulkedit/saveStatusDispositionV2`;
export const GET_RITM_WITH_TASKS = () => `AsknowRequest/servicenow/ritm`;

export const GET_TASK_STATES = () => `AsknowRequest/servicenow/task-states`;

export const UPDATE_TASK = () => `AsknowRequest/servicenow/task`;

export const BULK_UPDATE_TASKS = () => `AsknowRequest/servicenow/tasks/bulk`;

export const ADD_COMMENT_TO_TASK = () => `AsknowRequest/servicenow/task`;

export const REFRESH_RITM_CACHE = () => `AsknowRequest/servicenow/ritm`;

export const SEARCH_ASKNOW_USERS = () =>
  `AsknowRequest/servicenow/users/search`;
export const SAVE_EMPLOYEEDATE_OVERRIDES = () =>
  `centerpoint/saveEmployeeDateOverrides`;

export const GET_PORTFOLIO_LIST = () => `learnPoint/getPortfolioList`;
export const VALIDATE_NO_ROSTER_ID_EXCEL = () =>
  `omtTracker/validateNoRosterIdExcel`;
export const GET_NO_ROSTER_ORACLE_ID_DETAILS = () =>
  `omtTracker/getNoRosterOracleIdDetails`;
export const GET_LOG_INSIGHTS_SUMMARY = () => `loginsights/summary`;
export const GET_LOG_INSIGHTS_ERRORS = () => `loginsights/errors`;
export const CREATE_JIRA_BUG = () => `loginsights/create-jira-bug`;
export const NL_QUERY_ASK = () => `nlQuery/ask`;
export const AGENT_CHAT = () => `agent/chat`;
export const AGENT_CHAT_STREAM = () => `agent/chat/stream`;
export const AGENT_HEALTH = () => `agent/health`;
export const AGENT_FEEDBACK = () => `agent/feedback`;

// ASTT-7409: Copilot Studio integration -- parallel evaluation alongside the
// ADK/Cloud Run agent above (api/v1/agent/*), not a replacement. No stream
// variant -- Direct Line has no token-level streaming for Copilot Studio
// agents, unlike Cloud Run's SSE relay.
export const COPILOT_AGENT_CHAT = () => `copilotagent/chat`;
export const COPILOT_AGENT_HEALTH = () => `copilotagent/health`;
export const COPILOT_AGENT_FEEDBACK = () => `copilotagent/feedback`;
export const COPILOT_AGENT_SUGGESTIONS = () => `copilotagent/suggestions`;
